import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils.ts';
import featureFlags from 'services/featureFlags.ts';
import { AllowedTemplateKeys } from 'schemas/CampaignTemplates.schema.ts';

export interface ICampaignTemplate {
  id: string;
  version: number;
  name: string;
  properties: {
    key: AllowedTemplateKeys;
    value: string;
  }[];
}

export interface TemplatesResponse {
  templates: ICampaignTemplate[];
}

interface IFetchCampaignTemplatesForTeamVariables {
  teamId: string;
}

export default function useFetchCampaignTemplatesForTeam({ teamId }: IFetchCampaignTemplatesForTeamVariables) {
  const { tokens } = useAuth();
  return useQuery({
    queryKey: ['teamCampaignTemplates', { teamId }],
    queryFn: () => apiFetch<TemplatesResponse>({
      path: `team/${teamId}/templates`,
      method: 'GET',
      accessToken: String(tokens.accessToken),
    }),
    enabled: featureFlags.campaignTemplates && Boolean(teamId),
  });
}
